import {useEffect, useState} from "react"
import {Card, Col, Row} from "react-bootstrap";
import Form from "./Form";
import {UsePost, UsePut} from "../../hooks/http";
import {useNavigate} from "react-router-dom";
import {UseMessage} from "../../hooks/UseMessage";

const Create = () => {
    const navigate = useNavigate()
    const [errors, setErrors] = useState()
    const [plans, setPlans] = useState([])
    const [providers, setProviders] = useState({})
    const [isLoading, setIsLoading] = useState(false)




    const handleCreate = (PostData) => {
        setIsLoading(true)
        UsePost(
            '/accounts/upsert/',
            {data: PostData}
        ).then((response) => {
            if (response.code >= 200 && response.code <= 299) {
                navigate(`/accounts/${response.id}`)
                UseMessage('success', 'Account has been successfully created')
            } else {
                setErrors(response.errors)
            }
            setIsLoading(false)
        })
    }



    const GetEntities = async () => {
        const requestPlans = await UsePut(
            `/plans/get`,
            {data: {offset: 0}, toArray: true, propLabel: "name"}
        )

        const requestProviders = await UsePut(
            `/providers/get`,
            {data: {offset: 0}}
        )

        const smsProviders = [];
        const emailProviders = [];


        requestProviders?.entities?.length > 0 && requestProviders.entities.map((provider) => {
            if(provider?.channel === 'sms'){
                smsProviders.push({value: provider._id.$oid, label: provider.name})
            }
            if(provider?.channel === 'email'){
                emailProviders.push({value: provider._id.$oid, label: provider.name})
            }
        })


        return  {
            plans: requestPlans,
            providers: {
                sms: smsProviders,
                email: emailProviders
            },
        }
    }



    useEffect(() => {
        GetEntities().then((response) => {
            setPlans(response.plans)
            setProviders(response.providers)
            setIsLoading(false)
        })
    }, [])


    return (
        <>
            <Card>
                <Row>
                    <Col>
                        <div className="max-width-600">
                            <Form
                                plans={plans}
                                errors={errors}
                                isReady={!isLoading}
                                providers={providers}
                                onSubmit={handleCreate}
                            />
                        </div>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default Create